import { useEffect } from "react";
import { downloadFile } from "../../services/api";
import { Box, CircularProgress, Typography, Paper } from "@mui/material";
import { useParams } from "react-router-dom";

const DownloadPage = () => {
  const { downloadPath, version } = useParams();

  useEffect(() => {
    const downloadElement = async () => {
      await downloadFile(downloadPath, version);
      window.history.back();
    };
    downloadElement();
  }, []);

  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "#f9fafb",
        px: 2,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: 4,
          maxWidth: 400,
          width: "100%",
          textAlign: "center",
          borderRadius: 3,
        }}
      >
        <CircularProgress size={48} sx={{ mb: 3 }} />

        <Typography variant="h6" fontWeight={600} gutterBottom>
          Your download is starting…
        </Typography>

        <Typography variant="body2" color="text.secondary">
          Please wait while we prepare your file.
        </Typography>

        <Typography
          variant="caption"
          color="text.disabled"
          sx={{ display: "block", mt: 2 }}
        >
          If the download does not begin automatically, try refreshing the page.
        </Typography>
      </Paper>
    </Box>
  );
};

export default DownloadPage;
